import React from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import AhaBaseEventListener from 'components/common/AhaBaseEventListener';
import CardStylingMenu from './CardStylingMenu';
import CardLayoutEditorController from '../controllers/CardLayoutEditorController';
import { currentFlavorSupportsTeams } from 'javascripts/util/currentFlavorSupportsTeams';

const CardSettingsMenu = () => {
  const controller = useController(CardLayoutEditorController);
  const { currentCardView, currentRecordLayout, cardViewKey } = controller;
  const { availableCardStylings } = controller.currentRecordFields;
  const { hideRailsRenderingOptions } = controller.state;

  const menuContent: React.ReactNode[] = [];

  if (
    cardViewKey !== 'whiteboard' &&
    currentRecordLayout.parentRecordIsAvailable
  ) {
    menuContent.push(
      <aha-menu-item key='parent-record'>
        <label>
          <AhaBaseEventListener
            Component='aha-switch'
            active={currentCardView.showParentRecord || null}
            eventListeners={{
              'aha-switch:change': event =>
                controller.actionSetShowParentRecord(
                  event.currentTarget.active
                ),
            }}
          >
            Show parent record
          </AhaBaseEventListener>
        </label>
      </aha-menu-item>
    );
  }

  if (
    !(
      currentFlavorSupportsTeams() ||
      hideRailsRenderingOptions ||
      cardViewKey === 'whiteboard'
    )
  ) {
    menuContent.push(
      <aha-menu-item key='card-images'>
        <label>
          <AhaBaseEventListener
            Component='aha-switch'
            active={currentCardView.coverImages || null}
            eventListeners={{
              'aha-switch:change': event =>
                controller.actionSetShowCoverImages(event.currentTarget.active),
            }}
          >
            Show card images
          </AhaBaseEventListener>
        </label>
      </aha-menu-item>
    );
  }

  if (availableCardStylings.length > 1) {
    menuContent.push(
      <aha-menu-item key='useImprovedCard' role='menuitem' tabIndex={-1}>
        <CardStylingMenu
          availableCardStylings={availableCardStylings}
          selected={
            currentCardView.cardStyling
              ? currentCardView.cardStyling.type
              : null
          }
          onChange={type => controller.actionSetCardStyling(type)}
        />
      </aha-menu-item>
    );
  }

  if (menuContent.length < 1) {
    return (
      <aha-button disabled title='No settings available.'>
        <i className='fa-solid fa-gear' />
        <i className='fa-solid fa-caret-down' />
      </aha-button>
    );
  }

  return (
    <aha-menu>
      <aha-button slot='control'>
        <i className='fa-solid fa-gear' />
        <i className='fa-solid fa-caret-down' />
      </aha-button>
      <aha-menu-content>
        <aha-menu-group>{menuContent}</aha-menu-group>
      </aha-menu-content>
    </aha-menu>
  );
};

export default view(CardSettingsMenu);
